import { render, staticRenderFns } from "./privacy-switch.vue?vue&type=template&id=a568ae12&"
import script from "./privacy-switch.vue?vue&type=script&lang=js&"
export * from "./privacy-switch.vue?vue&type=script&lang=js&"
import style0 from "./privacy-switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports